import { MenuIcon } from 'components/icons'
import CurrentUserAvatar from 'components/layout/current-user-avatar'
import Logo from 'components/layout/logo'
import { useApp } from 'context/app-context'
import classNames from 'helpers/class-names'
import Link from 'next/link'

const NavigationMobile = () => {
  const { toggleMobileNavigation } = useApp()

  return (
    <nav
      className={classNames(
        'w-full bg-gray-500 px-2 pt-2 text-center md:hidden dark:bg-gray-900',
      )}>
      <div className={classNames('flex flex-row items-center text-left')}>
        <button
          onClick={() => toggleMobileNavigation()}
          className="-mt-2 rounded-lg p-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-info/75">
          <MenuIcon className="h-6 w-6 text-white" />
        </button>

        <div className="flex-1 text-center md:flex-none">
          <Link href="/">
            <a
              title="Toolpath"
              className="mx-auto inline-block rounded p-2 text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-info/75">
              <Logo className="w-40" />
            </a>
          </Link>
        </div>
        <CurrentUserAvatar className="mr-2 pb-1" />
      </div>
    </nav>
  )
}

export default NavigationMobile
